import ComponentManager from "../../../componentFramework";
import PrimeFacesUtil from "../PrimeFacesUtil";
import ElementAndSubtreeObserver from "../../../scripts/ElementAndSubtreeObserver";

/**
 * Documentation PrimeFaces:
 * 		JavaScript: https://primefaces.github.io/primefaces/jsdocs/classes/primefaces.widget.verticaltree.html
 * 		JSF Component: https://primefaces.github.io/primefaces/8_0/#/components/tree
 * 			Note: We are not on version 8 but that is what the above link is for.
 */
@ComponentManager.register()
export default class PrimeFacesTree {
	public static componentStyleClass = "ui-tree";
	private static initedStatic: boolean = false;

	private readonly jQuery: JQueryStatic;

	constructor(private readonly rootElement: HTMLElement) {
		if ((window as any).jQuery === undefined) {
			// This should never happen
			throw new Error(`Component failed to register: Can not find instance of jQuery.`);
		}
		this.jQuery = (window as any).jQuery;

		PrimeFacesTree.initStatic(this.jQuery);

		this.jQuery(rootElement).on("dragstart", this.onDragStart);

		PrimeFacesUtil.addWidgetListener("init", rootElement.id, this.onPrimeFacesWidgetInit, true);
	}

	@ComponentManager.on("removed")
	protected componentRemoved() {
		PrimeFacesUtil.removeWidgetListener("init", this.rootElement.id, this.onPrimeFacesWidgetInit);

		this.jQuery(this.rootElement).off("dragstart", this.onDragStart);
	}

	private static initStatic(jQuery: JQueryStatic) {
		if (!PrimeFacesTree.initedStatic) {
			PrimeFacesTree.initedStatic = true;
			ElementAndSubtreeObserver.getInstance().onElementWithStyleClass(
				"ui-treenode",
				elem => {
					// Disable dragging of all notes that are not "isViewSelectable"
					if (!elem.classList.contains("isViewSelectable")) {
						const draggableElems = elem.querySelectorAll(":scope > .ui-draggable");
						for (let i = 0; i < draggableElems.length; i++) {
							(jQuery(draggableElems[i]!) as any).draggable("disable");
						}
					}
				}
			);
		}
	}

	private readonly onPrimeFacesWidgetInit = (pfTreeWidget: any) => {
		// While the PrimeFaces tree widget has ".cfg.onNodeClick" to set a single listener, it can't
		// stop selection so we need to intercept the click instead, because we want the ability to stop selections based on what node is clicked.
		const originalNodeClick = pfTreeWidget.nodeClick;
		const onNodeClick = (ev: MouseEvent, treeNode: JQuery) => {
			for (let i = 0; i < treeNode.length; i++) {
				const parentElement = treeNode.get(i).parentElement;
				if (parentElement === null || !parentElement.classList.contains("isViewSelectable")) {
					return false;
				}
			}
			return true;
		}
		pfTreeWidget.nodeClick = function (ev: MouseEvent, treeNode: JQuery) {
			if (onNodeClick(ev, treeNode)) {
				originalNodeClick.call(this, ev, treeNode);
			}
		};
	}


	private readonly onDragStart = (event: any, ui: any) => {
		const itemBeingDragged = event.target;

		// Improve look of dragged item by copying the text of the dragged item into it.
		if (
			ui.helper !== undefined && ui.helper.length !== 0
			&& event.target !== undefined && event.target.textContent !== undefined
		) {
			const labelElem = itemBeingDragged.querySelector(".ui-treenode-label-text");
			if (labelElem !== null) {
				ui.helper[0].innerText = labelElem.innerText;
			} else {
				ui.helper[0].innerText = "";
			}
		}
	}
}
